/* Newsletter-Hinweis (Theme „Release“), angepasst für Rheinkauf (05.10.2026, M13; Rhein 03.11.2026)
 * - Erscheint frühestens nach 45 s Verweildauer (über Seitenwechsel hinweg gezählt,
 *   sessionStorage rk_nl_start) oder beim zweiten Seitenaufruf (rk_nl_seiten) nach kurzer Pause.
 * - Erscheint nicht, solange der Cookie-Hinweis bzw. die Cookie-Einstellungen offen sind (wartet auf
 *   rk:cookie-entschieden), ein Menü/Drawer offen ist oder gerade getippt wird.
 * - Jede Art zu schließen (Jetzt nicht, ×, Esc, Klick daneben) merkt sich die Entscheidung
 *   für data-tage Tage (Cookie newsletter-closed).
 * - Nach erfolgreicher Anmeldung (data-erfolg): Fenster öffnet sich einmal mit dem Rabattcode,
 *   danach ein Jahr lang nicht mehr (newsletter-subscribed). „Code kopieren“ über data-rk-kopieren.
 * setCookie/getCookie: assets/cookies.js · ModalDialog: assets/global.js
 */
class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.delay = Math.max(45, parseInt(this.dataset.delay, 10) || 45) * 1000;
    this.tage = Math.max(1, parseInt(this.dataset.tage, 10) || 30);
    this.form = this.querySelector('.js-form');
    this.geplant = false;
    this.wirdAngemeldet = false;

    this.querySelectorAll('.js-button-close').forEach((button) => {
      button.addEventListener('click', () => this.closeNewsletter());
    });

    if (this.form) {
      this.form.addEventListener('submit', this.onSubscribe.bind(this));
    }

    this.querySelectorAll('[data-rk-kopieren]').forEach((button) => {
      button.addEventListener('click', () => this.kopieren(button));
    });
  }

  connectedCallback() {
    if (window.Shopify && window.Shopify.designMode) {
      if (this.dataset.openInDesignMode === 'true') this.show();
      return;
    }

    if (this.dataset.erfolg === 'true') {
      const schonGezeigt = getCookie('newsletter-subscribed') === 'gezeigt';
      setCookie('newsletter-subscribed', 'gezeigt', 365);
      this.wirdAngemeldet = true;
      if (!schonGezeigt) setTimeout(() => this.show(), 400);
      return;
    }
    if (this.dataset.nurMerken === 'true') return;
    if (this.geplant) return;
    if (getCookie('newsletter-closed') === 'true' || getCookie('newsletter-subscribed')) return;

    this.geplant = true;
    const ageVerification = document.querySelector('age-verification-popup');
    if (ageVerification && getCookie('age-verified') !== 'true') {
      this.waitForAgeVerification(ageVerification);
      return;
    }
    this.planen();
  }

  waitForAgeVerification(ageVerification) {
    const observer = new MutationObserver(() => {
      if (getCookie('age-verified') === 'true') {
        observer.disconnect();
        this.planen();
      }
    });
    observer.observe(ageVerification, { attributes: true });
  }

  planen() {
    let start = Date.now();
    let seiten = 1;
    try {
      const gespeichert = parseInt(window.sessionStorage.getItem('rk_nl_start'), 10);
      if (gespeichert) {
        start = gespeichert;
      } else {
        window.sessionStorage.setItem('rk_nl_start', String(start));
      }
      seiten = (parseInt(window.sessionStorage.getItem('rk_nl_seiten'), 10) || 0) + 1;
      window.sessionStorage.setItem('rk_nl_seiten', String(seiten));
    } catch (e) {
      /* privates Fenster o. Ä.: ab jetzt zählen */
    }
    let rest = this.delay - (Date.now() - start);
    if (seiten >= 2) rest = Math.min(rest, 6000);
    setTimeout(() => this.zeigenWennRuhig(), Math.max(3000, rest));
  }

  zeigenWennRuhig() {
    if (getCookie('newsletter-closed') === 'true' || getCookie('newsletter-subscribed')) return;

    const html = document.documentElement;
    if (html.classList.contains('rk-cookie-offen')) {
      document.addEventListener(
        'rk:cookie-entschieden',
        () => setTimeout(() => this.zeigenWennRuhig(), 8000),
        { once: true }
      );
      return;
    }

    const aktiv = document.activeElement;
    const tippt = aktiv && /^(INPUT|TEXTAREA|SELECT)$/.test(aktiv.tagName);
    const beschaeftigt =
      tippt ||
      html.classList.contains('rk-nav-offen') ||
      document.body.classList.contains('drawer--is-open') ||
      document.getElementById('rk-cookie-prefs') ||
      document.querySelector('.rk-mega.is-open, dialog[open], details.drawer__container[open]');
    if (beschaeftigt) {
      setTimeout(() => this.zeigenWennRuhig(), 5000);
      return;
    }

    this.show();
  }

  kopieren(button) {
    const code = button.getAttribute('data-rk-kopieren') || '';
    const status = this.querySelector('[data-rk-kopiert]');
    const fertig = (ok) => {
      if (status) status.textContent = ok ? 'Kopiert – an der Kasse einfügen.' : 'Bitte den Code oben markieren und kopieren.';
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(() => fertig(true), () => fertig(false));
    } else {
      fertig(false);
    }
  }

  closeNewsletter() {
    this.hide();
  }

  hide() {
    if (!this.wirdAngemeldet && this.hasAttribute('open')) {
      setCookie('newsletter-closed', 'true', this.tage);
    }
    super.hide();
  }

  onSubscribe() {
    this.wirdAngemeldet = true;
    setCookie('newsletter-subscribed', 'true', 365);
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
